import { RefItem, TicketStatus } from "@share/committees/common/types/TicketStatus";

import { TicketRowInterfaceView, TicketRowInterfaceForm } from "@share/committees/common/types/interfaces/TicketsRowInterface";

class TableRowModel<T>  {
    id: string;
    title: string;

    //dates
    createdAt?: string; //дата подачи
    implementedAt?: string; //дата реализации

    status: TicketStatus;

    //profiles
    ownerIds: number[]
    responsibleUserId: number; //ответственный
    responsibleForImplementationUserId: number; //ответственный за реализацию

    selected = false;

    constructor(data: T, isSelected = false) {
        Object.assign(this, data);
        this.selected = isSelected;
    }

    get autorId() {
        return this.ownerIds?.[0]
    }
}

export class TableRowModelForm extends TableRowModel<TicketRowInterfaceForm> implements TicketRowInterfaceForm {
    company?: RefItem;
    category: RefItem;

    constructor(data: TicketRowInterfaceForm, isSelected = false) {
        super(data, isSelected);
    }
}

export class TableRowModelView extends TableRowModel<TicketRowInterfaceView> implements TicketRowInterfaceView {

    constructor(data: TicketRowInterfaceView, isSelected = false) {
        super(data, isSelected);
    }
}